import { useContext, useMemo } from "react";
import MerchantContext from "../../contexts/MerchantContext";
import { Card, CardContent } from "@/components/ui/card";
import {
  renderTemplatePreview,
  type MappableLead,
  type VariableMapping,
} from "./variableMapping";

type TemplatePreviewCardProps = {
  bodyText: string | undefined;
  variableMapping: VariableMapping;
  sampleLead: MappableLead | undefined;
};

// Renders the message as the sample lead would receive it — shown on both the
// Variables and Confirmar steps of the preselected wizard.
const TemplatePreviewCard = ({
  bodyText,
  variableMapping,
  sampleLead,
}: TemplatePreviewCardProps) => {
  const { displayName } = useContext(MerchantContext);

  const preview = useMemo(() => {
    if (!bodyText || !sampleLead) return null;
    return renderTemplatePreview(bodyText, variableMapping, sampleLead, displayName || "");
  }, [bodyText, variableMapping, sampleLead, displayName]);

  return (
    <Card className="border-purple-200 bg-purple-50">
      <CardContent className="p-4">
        <p className="mb-2 text-sm font-medium text-purple-700">Vista previa del mensaje:</p>
        <p className="whitespace-pre-wrap text-sm text-gray-700">{preview}</p>
      </CardContent>
    </Card>
  );
};

export default TemplatePreviewCard;
